import EnableMonitoringButton from "../Monitoring/EnrollmentButton";

export interface Props {
  domain: string;
  disabled: boolean;
}

export default function InlineEnableMonitoringButton({
  domain,
  disabled,
}: Props) {
  return (
    // Spacing is the caller's business: this button sits in a flex row with
    // a gap, and a margin of its own only shows up as one uneven seam.
    <EnableMonitoringButton domain={domain} disabled={disabled} />
  );
}
